<template>
  <div class="manicure-page">
    <header class="hero">
        <div class="logo">
            <img src="@/assets/landpages/manicure/images/logo.png" alt="Logo Horabela">
        </div>

        <div class="hero-content">
            <h1>Pare de trabalhar no escuro.<br>Saiba exatamente quanto seu Studio está lucrando.</h1>

            <p>
                Organize seus atendimentos, acompanhe seus ganhos e tenha clareza total do seu lucro —
                sem planilhas, sem cadernos e sem dor de cabeça.
            </p>

            <ul class="hero-benefits">
                <li>✔ Veja quanto ganhou por dia, semana e mês</li>
                <li>✔ Controle serviços e valores automaticamente</li>
                <li>✔ Tenha o financeiro do seu Studio na palma da mão</li>
            </ul>

            <a href="https://app.horabela.com.br/registro" class="cta" id="cta_hero_manicure">
                Quero ver meu lucro real
            </a>

            <p class="trial-info">30 dias grátis — Sem compromisso e sem cartão</p>
        </div>

        <div class="hero-media">
            <img src="@/assets/landpages/manicure/images/dashboboard-manicures.png" alt="Sistema Horabela no Celular">
        </div>
    </header>

    <div class="mini-cta">
        <h3>A ferramenta favorita das Nail Designers que buscam profissionalismo</h3>
        <a href="https://app.horabela.com.br/registro" class="cta" >Quero participar</a>
    </div>

    <section class="benefits">
        <h2>Por que escolher o Horabela para o seu Studio?</h2>
        <ul>
            <li>✅ <b>Cálculo Automático:</b> Comissões separadas por profissional e serviço na hora.</li>
            <li>✅ <b>Registro Ágil:</b> Lance alongamentos, banhos de gel e decorações em segundos.</li>
            <li>✅ <b>Gestão de Insumos:</b> Controle o estoque de géis, lixas e esmaltes com facilidade.</li>
            <li>✅ <b>Histórico de Clientes:</b> Saiba os serviços realizados por cada cliente.</li>
            <li>✅ <b>Relatórios Financeiros:</b> Entenda seu lucro real.</li>
            <li>✅ <b>Multi-plataforma:</b> Gerencie sua esmalteria pelo celular, tablet ou computador.</li>
        </ul>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center" id="cta_beneficios_manicure">Organizar meu negócio</a>
    </section>

    <section class="before-after">
        <h2>A evolução da sua gestão</h2>

        <div class="ba-grid">
            <div class="before">
                <h3>Sem o Horabela</h3>
                <ul>
                    <li>❌ Fim do dia perdido somando comandas de papel.</li>
                    <li>❌ Erros no pagamento das comissões das manicures.</li>
                    <li>❌ Falta de material no meio de um atendimento.</li>
                    <li>❌ Insegurança sobre o quanto realmente sobrou de lucro.</li>
                </ul>
            </div>

            <div class="after">
                <h3>Com o Horabela</h3>
                <ul>
                    <li>✅ Fechamento de caixa automático e sem erros.</li>
                    <li>✅ Transparência total e confiança com sua equipe.</li>
                    <li>✅ Estoque sempre em dia com alertas de reposição.</li>
                    <li>✅ Clareza absoluta do crescimento da sua esmalteria.</li>
                </ul>
            </div>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero esse resultado</a>
    </section>

    <section class="story">
        <h2>Você cuida das unhas, nós cuidamos dos números</h2>
        <p>Sabemos que a vida de Nail Designer é intensa. Entre uma aplicação e outra, é fácil se perder nas contas. O Horabela foi criado para ser o seu braço direito, garantindo que você nunca mais perca dinheiro por falta de organização ou erro de cálculo.</p>

        <div class="story-media">
            <!-- <img src="@/assets/landpages/manicure/images/studio-ambiente.png" alt="Ambiente organizado com Horabela"> -->
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Parar de perder tempo</a>
    </section>

    <section class="social-proof">
        <h2>Studio de Nails que já confiam no Horabela</h2>

        <div class="testimonials">
            <blockquote>
                "Minhas manicures amam! Elas acompanham o quanto ganharam no dia pelo próprio celular."
                <span>— Studio Nails Gold</span>
            </blockquote>

            <blockquote>
                "O controle de estoque me deu uma paz enorme. Agora nunca falta o gel que eu mais uso."
                <span>— Amanda Costa, Nail Designer</span>
            </blockquote>

            <blockquote>
                "Antes eu demorava 2 horas para fechar o caixa do mês. Com o Horabela, faço em 5 minutos."
                <span>— Esmalteria & Cia</span>
            </blockquote>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Ser uma profissional organizada</a>
    </section>

    <section class="faq">
        <h2>Perguntas Frequentes</h2>

        <div class="faq-item">
            <button class="faq-question">O sistema serve para quem trabalha sozinha?</button>
            <div class="faq-answer">
                <p>Sim! Ele é perfeito para organizar suas finanças pessoais e profissionais de forma separada.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">É seguro colocar meus dados financeiros?</button>
            <div class="faq-answer">
                <p>Totalmente. Utilizamos tecnologia de criptografia de ponta para garantir que seus dados estejam protegidos.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Tem algum custo de instalação?</button>
            <div class="faq-answer">
                <p>Nenhum. Você começa a usar agora mesmo e conta com nosso suporte para qualquer dúvida.</p>
            </div>
        </div>

                <div class="faq-item">
            <button class="faq-question">Posso cancelar quando quiser?</button>
            <div class="faq-answer">
                <p>Pode sim. Não tem fidelidade e você cancela quando quiser.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Preciso colocar cartão para testar?</button>
            <div class="faq-answer">
                <p>Não precisa. Você testa grátis sem colocar cartão e sem compromisso.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Funciona no celular?</button>
            <div class="faq-answer">
                <p>Sim. Funciona no celular, tablet e computador.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">O cálculo de comissão é automático?</button>
            <div class="faq-answer">
                <p>Sim. O sistema calcula tudo sozinho, por serviço e por manicure.</p>
            </div>
        </div>

        <a href="https://wa.me/5581996280480" target="_blank" class="cta cta-center" id="cta_faq_manicure">Tirar dúvidas pelo WhatsApp</a>
    </section>

    <section class="offer">
        <h2>Pronta para o próximo nível?</h2>
        <p class="trial-info">Comece agora e ganhe suporte prioritário na configuração do seu Studio</p>

        <a href="https://app.horabela.com.br/registro" class="cta">Ativar meu teste grátis</a>
    </section>

    <footer>
        <p>Horabela © Todos os direitos reservados</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Manicure',
  data() {
    return {
      // Suas variáveis de dados aqui
    }
  },
  mounted() {
    // FAQ Toggle
    const questions = document.querySelectorAll('.faq-question');
    questions.forEach(q => {
        q.addEventListener('click', () => {
            const answer = q.nextElementSibling;
            answer.classList.toggle('open');
            q.classList.toggle('active');
        });
    });
  },
  methods: {
    // Seus métodos aqui
  }
}
</script>

<style scoped>
@import '@/assets/landpages/manicure/css/styles.css';
</style>
